import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';

export default class UserLeaderboardPage extends UserPage {
  parseQueryParams() {
    const params = new URLSearchParams(window.location.search);
    return {
      period: params.get('period') || 'alltime',
      tab: params.get('tab') || 'personal',
      page: parseInt(params.get('page') || '1')
    };
  }

  oninit(vnode) {
    super.oninit(vnode);
    
    // 加载用户
    this.loadUser(m.route.param('username'));
    
    const q = this.parseQueryParams();
    this.period = q.period;
    this.activeTab = q.tab;
    this.currentPage = q.page;
    
    this.pointsBoardList = [];
    this.groupBoardList = [];
    this.groupMeta = {};
    this.loading = true;
    this.hasMore = false;
    this.meta = {};
    this.periodOpen = false;
  }

  show(user) {
    super.show(user);
    
    // 用户加载完成后，加载排行榜数据
    if (this.user) {
      this.loadResults();
    }
  }

  onupdate() {
    const q = this.parseQueryParams();
    const newPeriod = q.period;
    const newTab = q.tab;
    const newPage = q.page;
    
    if (this.period !== newPeriod || this.activeTab !== newTab || this.currentPage !== newPage) {
      this.period = newPeriod;
      this.activeTab = newTab;
      this.currentPage = newPage;
      this.pointsBoardList = [];
      this.loading = true;
      this.loadResults();
    }
  }

  buildQuery(params) {
    const q = new URLSearchParams();
    if (params.period) q.set('period', params.period);
    if (params.tab) q.set('tab', params.tab);
    if (params.page && params.page > 1) q.set('page', params.page);
    const query = q.toString();
    return query ? '?' + query : '';
  }

  content() {
    if (this.loading && this.pointsBoardList.length === 0 && (this.activeTab !== 'group' || this.groupBoardList.length === 0)) {
      return (
        <div className="UserLeaderboardPage">
          <LoadingIndicator />
        </div>
      );
    }

    return (
      <div className="UserLeaderboardPage">
        {this.renderHeader()}
        {this.renderTabs()}
        {this.renderContent()}
      </div>
    );
  }

  renderHeader() {
    const periodLabel = () => {
      switch (this.period) {
        case 'week': return app.translator.trans('tf-points.forum.leaderboard-period-week');
        case 'month': return app.translator.trans('tf-points.forum.leaderboard-period-month');
        case 'year': return app.translator.trans('tf-points.forum.leaderboard-period-year');
        default: return app.translator.trans('tf-points.forum.leaderboard-period-all-time');
      }
    };

    return (
      <div className="PointsLeaderboardPage-header">
        {/* <h2 className="PointsLeaderboardPage-title">
          {app.translator.trans('tf-points.forum.leaderboard-page-title')}
        </h2> */}
        <div className="PointsLeaderboardPage-periodDropdown">
          <button className="Button Button--link" onclick={() => { this.periodOpen = !this.periodOpen; m.redraw(); }}>
            {periodLabel()} <i className="fa-light fa-chevron-down"></i>
          </button>
          {this.periodOpen && (
            <ul className="PointsLeaderboardPage-menu">
              {['alltime', 'week', 'month', 'year'].map(key => (
                <li>
                  <button className={`Button Button--link ${this.period === key ? 'is-active' : ''}`}
                    onclick={() => {
                      this.period = key;
                      this.periodOpen = false;
                      this.currentPage = 1;
                      this.pointsBoardList = [];
                      this.loading = true;
                      const username = this.user ? this.user.slug() : m.route.param('username');
                      m.route.set(app.route('user.mentions', { username }) + this.buildQuery({ period: key, tab: this.activeTab }));
                      this.loadResults();
                    }}>
                    {key === 'alltime' ? app.translator.trans('tf-points.forum.leaderboard-period-all-time') :
                     key === 'week' ? app.translator.trans('tf-points.forum.leaderboard-period-week') :
                     key === 'month' ? app.translator.trans('tf-points.forum.leaderboard-period-month') :
                     app.translator.trans('tf-points.forum.leaderboard-period-year')}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    );
  }

  renderTabs() {
    const username = this.user ? this.user.slug() : m.route.param('username');
    
    return (
      <div className="PointsLeaderboardPage-tabs">
        <button
          className={`Button Button--link ${this.activeTab === 'personal' ? 'is-active' : ''}`}
          onclick={() => {
            if (this.activeTab !== 'personal') {
              this.activeTab = 'personal';
              this.currentPage = 1;
              this.pointsBoardList = [];
              this.loading = true;
              m.route.set(app.route('user.mentions', { username }) + this.buildQuery({ period: this.period, tab: 'personal' }));
              this.loadResults();
            }
          }}
        >{app.translator.trans('tf-points.forum.leaderboard-tab-moderators')}</button>

        <button
          className={`Button Button--link ${this.activeTab === 'users' ? 'is-active' : ''}`}
          onclick={() => {
            if (this.activeTab !== 'users') {
              this.activeTab = 'users';
              this.currentPage = 1;
              this.pointsBoardList = [];
              this.loading = true;
              m.route.set(app.route('user.mentions', { username }) + this.buildQuery({ period: this.period, tab: 'users' }));
              this.loadResults();
            }
          }}
        >{app.translator.trans('tf-points.forum.leaderboard-tab-users')}</button>

        <button
          className={`Button Button--link ${this.activeTab === 'group' ? 'is-active' : ''}`}
          onclick={() => {
            if (this.activeTab !== 'group') {
              this.activeTab = 'group';
              this.currentPage = 1;
              this.groupBoardList = [];
              this.loading = true;
              m.route.set(app.route('user.mentions', { username }) + this.buildQuery({ period: this.period, tab: 'group' }));
              this.loadGroupResults();
            }
          }}
        >{app.translator.trans('tf-points.forum.leaderboard-tab-groups')}</button>
      </div>
    );
  }

  renderContent() {
    if (this.activeTab === 'group') {
      return this.renderGroupList();
    }

    return this.renderPersonalList();
  }

  renderPersonalList() {
    const renderAvatar = (item, size = 'normal') => {
      const url = item?.attributes?.avatarUrl || item?.attributes?.cover_image;
      const name = item?.attributes?.displayName || item?.attributes?.username || '';
      const initial = (name || '?').toString().charAt(0).toUpperCase();
      const isLarge = size === 'large';
      const avatarClass = isLarge ? 'LeaderboardTop-avatar-img' : 'LeaderboardList-avatar-img';
      const fallbackClass = isLarge ? 'LeaderboardTop-avatar-fallback' : 'LeaderboardList-avatar-fallback';
      
      if (url) {
        return <img className={avatarClass} src={url} alt={name} />;
      }
      return <div className={fallbackClass}>{initial}</div>;
    };

    const baseRank = (this.currentPage - 1) * 20;
    const isFirstPage = this.currentPage === 1;
    const topThree = isFirstPage ? this.pointsBoardList.slice(0, 3) : [];
    const restList = isFirstPage ? this.pointsBoardList.slice(3) : this.pointsBoardList;

    return (
      <div className="LeaderboardPage-container">
        {/* Top 3 特殊显示（仅第一页） */}
        {isFirstPage && topThree.length > 0 && (
          <div className="LeaderboardTop-three">
            {topThree.map((item, idx) => {
              const rank = idx + 1;
              const name = item?.attributes?.displayName || item?.attributes?.username || 'Unknown';
              const pts = item?.attributes?.points || 0;
              const borderColor = rank === 1 ? 'gold' : rank === 2 ? 'blue' : 'red';
              const badgeColor = rank === 1 ? 'gold' : rank === 2 ? 'blue' : 'red';
              
              return (
                <div key={idx} className={`LeaderboardTop-item LeaderboardTop-item-${borderColor}`}>
                  <div className="LeaderboardTop-avatar-wrapper">
                    {renderAvatar(item, 'large')}
                    <div className={`LeaderboardTop-badge LeaderboardTop-badge-${badgeColor}`}>
                      {rank}
                    </div>
                  </div>
                  <div className="LeaderboardTop-name">{name}</div>
                  <div className="LeaderboardTop-points">{pts.toLocaleString()} pts</div>
                </div>
              );
            })}
          </div>
        )}

        {/* 排名 4+ 列表显示（第一页）或完整列表（其他页） */}
        {restList.length > 0 && (
          <div className="LeaderboardList">
            {restList.map((item, idx) => {
              const rank = isFirstPage ? baseRank + 4 + idx : baseRank + idx + 1;
              const name = item?.attributes?.displayName || item?.attributes?.username || 'Unknown';
              const pts = item?.attributes?.points || 0;
              
              return (
                <div key={idx} className="LeaderboardList-item">
                  <div className="LeaderboardList-rank">{rank}</div>
                  <div className="LeaderboardList-avatar">{renderAvatar(item, 'normal')}</div>
                  <div className="LeaderboardList-name">{name}</div>
                  <div className="LeaderboardList-points">{pts.toLocaleString()} pts</div>
                </div>
              );
            })}
          </div>
        )}

        {this.renderPagination()}
      </div>
    );
  }

  renderGroupList() {
    if (this.groupBoardList.length === 0 && !this.loading) {
      return (
        <div className="PointsLeaderboardPage-empty">
          {app.translator.trans('tf-points.forum.leaderboard-empty')}
        </div>
      );
    }
    
    const renderAvatar = (item) => {
      const url = item?.attributes?.cover_image;
      const name = item?.attributes?.name;
      const initial = (name || '?').toString().charAt(0).toUpperCase();
      if (url) {
        return <img className="LeaderboardPage-avatar-img" src={url} alt={name} />;
      }
      return <div className="LeaderboardPage-avatar-fallback">{initial}</div>;
    };

    return (
      <div className="PointsLeaderboardPage-list">
        <div className="PointsLeaderboardPage-list-header">
          <div className="PointsLeaderboardPage-list-header-rank">{app.translator.trans('tf-points.forum.leaderboard-list-rank')}</div>
          <div className="PointsLeaderboardPage-list-header-user">{app.translator.trans('tf-points.forum.leaderboard-list-group')}</div>
          <div className="PointsLeaderboardPage-list-header-points">{app.translator.trans('tf-points.forum.leaderboard-list-points')}</div>
        </div>
        <ol className="PointsLeaderboardPage-items">
          {this.groupBoardList.map((item, idx) => {
            const name = item?.attributes?.name || 'Group';
            const heat = item?.attributes?.heat_total || 0;
            const rank = (this.currentPage - 1) * 20 + idx + 1;
            return (
              <li className="PointsLeaderboardPage-item" key={item.id || idx}>
                <div className="PointsLeaderboardPage-item-rank">{rank}</div>
                <div className="PointsLeaderboardPage-item-avatar">
                  <div className="PointsLeaderboardPage-item-avatar">{renderAvatar(item)}</div>
                </div>
                <div className="LeaderboardPage-name">{name}</div>
                <div className="PointsLeaderboardPage-item-points">{heat} <i className="fa-light fa-fire" style="color: #ff6d00;"></i></div>
              </li>
            );
          })}
        </ol>
        {this.renderGroupPagination()}
      </div>
    );
  }

  renderGroupPagination() {
    const meta = this.groupMeta || {};
    if (!meta.pageCount || meta.pageCount <= 1) {
      return null;
    }

    const pages = [];
    const pageCount = meta.pageCount;
    const current = this.currentPage;
    const username = this.user ? this.user.slug() : m.route.param('username');
    
    // Previous button
    pages.push(
      <button
        className="Button Button--link"
        disabled={current === 1}
        onclick={() => {
          if (current > 1) {
            this.currentPage = current - 1;
            m.route.set(app.route('user.mentions', { username }) + this.buildQuery({ period: this.period, tab: this.activeTab, page: this.currentPage }));
            this.loadGroupResults();
          }
        }}
      >« {app.translator.trans('core.forum.index.previous_page')}</button>
    );

    // Page numbers
    for (let i = 1; i <= pageCount; i++) {
      if (i === 1 || i === pageCount || (i >= current - 2 && i <= current + 2)) {
        pages.push(
          <button
            className={`Button Button--link ${current === i ? 'is-active' : ''}`}
            onclick={() => {
              this.currentPage = i;
              m.route.set(app.route('user.mentions', { username }) + this.buildQuery({ period: this.period, tab: this.activeTab, page: i }));
              this.loadGroupResults();
            }}
          >{i}</button>
        );
      } else if (i === current - 3 || i === current + 3) {
        pages.push(<span className="LeaderboardPage-pagination-ellipsis">…</span>);
      }
    }

    // Next button
    pages.push(
      <button
        className="Button Button--link"
        disabled={current === pageCount}
        onclick={() => {
          if (current < pageCount) {
            this.currentPage = current + 1;
            m.route.set(app.route('user.mentions', { username }) + this.buildQuery({ period: this.period, tab: this.activeTab, page: this.currentPage }));
            this.loadGroupResults();
          }
        }}
      >{app.translator.trans('core.forum.index.next_page')} »</button>
    );

    return (
      <div className="PointsLeaderboardPage-pagination">
        {pages}
      </div>
    );
  }

  renderPagination() {
    if (!this.meta || !this.meta.pageCount || this.meta.pageCount <= 1) {
      return null;
    }

    const pages = [];
    const pageCount = this.meta.pageCount;
    const current = this.currentPage;
    const username = this.user ? this.user.slug() : m.route.param('username');
    
    // Previous button
    pages.push(
      <button
        className="Button Button--link"
        disabled={current === 1}
        onclick={() => {
          if (current > 1) {
            this.currentPage = current - 1;
            m.route.set(app.route('user.mentions', { username }) + this.buildQuery({ period: this.period, tab: this.activeTab, page: this.currentPage }));
            this.loadResults();
          }
        }}
      >« {app.translator.trans('core.forum.index.previous_page')}</button>
    );

    // Page numbers
    for (let i = 1; i <= pageCount; i++) {
      if (i === 1 || i === pageCount || (i >= current - 2 && i <= current + 2)) {
        pages.push(
          <button
            className={`Button Button--link ${current === i ? 'is-active' : ''}`}
            onclick={() => {
              this.currentPage = i;
              m.route.set(app.route('user.mentions', { username }) + this.buildQuery({ period: this.period, tab: this.activeTab, page: i }));
              this.loadResults();
            }}
          >{i}</button>
        );
      } else if (i === current - 3 || i === current + 3) {
        pages.push(<span className="LeaderboardPage-pagination-ellipsis">…</span>);
      }
    }

    // Next button
    pages.push(
      <button
        className="Button Button--link"
        disabled={current === pageCount}
        onclick={() => {
          if (current < pageCount) {
            this.currentPage = current + 1;
            m.route.set(app.route('user.mentions', { username }) + this.buildQuery({ period: this.period, tab: this.activeTab, page: this.currentPage }));
            this.loadResults();
          }
        }}
      >{app.translator.trans('core.forum.index.next_page')} »</button>
    );

    return (
      <div className="PointsLeaderboardPage-pagination">
        {pages}
      </div>
    );
  }

  loadResults() {
    if (this.activeTab === 'group') {
      this.loadGroupResults();
      return;
    }

    this.loading = true;
    const limit = 20;
    const offset = (this.currentPage - 1) * limit;

    return app.store
      .find("pointsboard", {
        page: {
          offset,
          limit
        },
        period: this.period
      })
      .catch((error) => {
        console.error('Error loading points leaderboard:', error);
        this.loading = false;
        m.redraw();
        return null;
      })
      .then((results) => {
        if (results) {
          this.parseResults(results);
        }
      });
  }

  loadGroupResults() {
    this.loading = true;
    const limit = 20;
    const page = this.currentPage;

    return app.request({
      method: 'GET',
      url: `${app.forum.attribute('apiUrl')}/social-groups/heat-rank`,
      params: {
        period: this.period === 'alltime' ? 'month' : this.period,
        page: {
          number: page,
          limit: limit
        }
      }
    }).then((response) => {
      this.parseGroupResults(response);
    }).catch((error) => {
      console.error('Error loading group heat rank:', error);
      this.loading = false;
      this.groupBoardList = [];
      m.redraw();
    });
  }

  parseGroupResults(response) {
    try {
      let data = [];
      if (response.data && Array.isArray(response.data)) {
        data = response.data;
        // 计算分页信息
        if (response.links) {
          const hasNext = !!response.links.next;
          const totalItems = this.groupBoardList.length + data.length;
          this.groupMeta = {
            pageCount: hasNext ? this.currentPage + 1 : Math.ceil(totalItems / 20),
            currentPage: this.currentPage,
            hasNext: hasNext
          };
        } else {
          this.groupMeta = {
            pageCount: this.currentPage,
            currentPage: this.currentPage,
            hasNext: false
          };
        }
      }

      if (Array.isArray(data) && data.length > 0) {
        this.groupBoardList = data;
      } else {
        this.groupBoardList = [];
      }

      this.loading = false;
      m.redraw();
    } catch (error) {
      console.error('Error parsing group results:', error);
      this.loading = false;
      this.groupBoardList = [];
      m.redraw();
    }
  }

  parseResults(results) {
    try {
      let data = [];
      if (results.data && Array.isArray(results.data)) {
        data = results.data;
        this.hasMore = !!results.links && !!results.links.next;
        this.meta = results.meta || {};
      } else if (Array.isArray(results)) {
        data = results;
        this.hasMore = false;
      }

      if (Array.isArray(data) && data.length > 0) {
        const formattedData = data.map(item => {
          if (item.data) {
            return item.data;
          } else if (item.attributes) {
            return item;
          } else {
            return item;
          }
        });
        this.pointsBoardList = formattedData;
      }

      this.loading = false;
      m.redraw();
    } catch (error) {
      console.error('Error parsing results:', error);
      this.loading = false;
      m.redraw();
    }
  }
}

